type OverlayOwner = { streamId: string | null; editing: boolean };

// Read ownership at the time of the write, including deferred resize/cleanup
// callbacks. A callback captured before a focus change must not regain ownership.
export const createPlayerOverlayPersistence = <Layout,>(
  getOwner: () => OverlayOwner,
  save: (layout: Layout) => void,
) => ({
  saveViewer(streamId: string, layout: Layout) {
    const owner = getOwner();
    if (owner.streamId === streamId && !owner.editing) save(layout);
  },
  saveEditor(streamId: string | null, layout: Layout) {
    // The closing editor may flush its last drag before it is destroyed.
    if (getOwner().streamId === streamId) save(layout);
  },
});
